import { ErrorBoundary, withSentryReactRouterV6Routing } from '@sentry/react'
import TagManager from 'react-gtm-module'
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom'

import { AppLayout } from '@layouts/app_layout'
import { OfferLayout } from '@layouts/offer_layout'
import { PageLayout } from '@layouts/page_layout'
import { ProfileLayout } from '@layouts/profile_layout'
import { useLocationContext } from '@providers/location'
import { NotFound } from '@views/not_found'
import { routeComponents } from './route_components'
import { routeKeys, routes } from './routes_definitions'
import type { TRouteConfig } from './types'

const routesBySection = routeKeys.reduce(
  (acc, key) => {
    const route = { ...routes[key], uid: key, component: routeComponents[key] }
    acc[route.section] = acc[route.section] || []
    acc[route.section].push(route)
    return acc
  },
  {} as Record<string, TRouteConfig[]>
)

const SentryRoutes = withSentryReactRouterV6Routing(Routes)

const sectionLayoutMap = {
  initial: null,
  pages: <PageLayout />,
  offers: <OfferLayout />,
  profile: <ProfileLayout />,
  noHeaderPages: null,
} as GenericSimpleBag

const RouteConfig = () => {
  const { location } = useLocationContext()

  if (location) {
    TagManager.dataLayer({
      dataLayer: {
        location: {
          name: location?.name,
        },
      },
    })
  }

  const renderRoute = (routeConfig: TRouteConfig) => {
    const Element = routeConfig.component
    return <Route key={routeConfig.uid} element={<Element />} path={routeConfig.path} />
  }

  return (
    <ErrorBoundary fallback={<NotFound />}>
      <SentryRoutes>
        {Object.keys(routesBySection).map((section) => (
          <Route key={section} element={<AppLayout routeConfigs={routesBySection[section]} />}>
            <Route element={sectionLayoutMap[section]}>{routesBySection[section].map(renderRoute)}</Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        ))}
      </SentryRoutes>
    </ErrorBoundary>
  )
}

const router = createBrowserRouter([{ path: '*', Component: RouteConfig }])
//   {
//   future: {
//     v7_fetcherPersist: true,
//     v7_normalizeFormMethod: true,
//     v7_partialHydration: true,
//     v7_relativeSplatPath: true,
//     v7_skipActionErrorRevalidation: true,
//   },
// }

export const AppRoutes = () => {
  return <RouterProvider router={router} future={{ v7_startTransition: true }} />
}
